/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLeagueTeamsResponsePagination
 */
export interface GetLeagueTeamsResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetLeagueTeamsResponsePagination
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLeagueTeamsResponsePagination
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLeagueTeamsResponsePagination
     */
    offset?: number;
}

/**
 * Check if a given object implements the GetLeagueTeamsResponsePagination interface.
 */
export function instanceOfGetLeagueTeamsResponsePagination(value: object): value is GetLeagueTeamsResponsePagination {
    return true;
}

export function GetLeagueTeamsResponsePaginationFromJSON(json: any): GetLeagueTeamsResponsePagination {
    return GetLeagueTeamsResponsePaginationFromJSONTyped(json, false);
}

export function GetLeagueTeamsResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueTeamsResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
    };
}

export function GetLeagueTeamsResponsePaginationToJSON(json: any): GetLeagueTeamsResponsePagination {
    return GetLeagueTeamsResponsePaginationToJSONTyped(json, false);
}

export function GetLeagueTeamsResponsePaginationToJSONTyped(value?: GetLeagueTeamsResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

